module.exports = __webpack_public_path__ + "static/media/benefits.ec6d7194.mp3";